export enum RoleEnum {
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_AGENCY = 'ROLE_AGENCY',
  ROLE_REPRESENTATIVE = 'ROLE_REPRESENTATIVE',
  ROLE_AMICA_EMPLOYEE = 'ROLE_AMICA_EMPLOYEE',
}
